var map = {
	"./cover.js": 60,
	"./default.js": 67,
	"./render.js": 34
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;


//////////////////
// WEBPACK FOOTER
// ./src/controllers/templates .(js)$
// module id = 129
// module chunks = 0